import { useQuery } from "@apollo/react-hooks";
import { GET_PRESCRIPTION_AVAILABLE_BY_DOCTOR } from "../queries";

export const NO_PRESCRIPTION_AVAILABLE_MESSAGE =
  "No tiene recetarios disponibles. Debe comprar recetarios para continuar.";

// Debe coincidir con PRESCRIPTION_PURCHASE_ENFORCED del API. Mientras sea false
// no se bloquea ninguna receta por falta de recetarios; cambiar a true para activarla.
export const PRESCRIPTION_PURCHASE_ENFORCED = false;

// Las recetas PYP no consumen recetarios; el resto descuenta uno por receta generada.
export const requiresPrescriptionPurchase = (recipeType) =>
  PRESCRIPTION_PURCHASE_ENFORCED && !!recipeType && !recipeType.isPyp;

export default function usePrescriptionAvailability({
  medicalStaffId,
  branchOfficeId,
  pharmacyProviderId,
}) {
  const { data: { getPrescriptionAvailableByDoctor } = {}, loading, refetch } =
    useQuery(GET_PRESCRIPTION_AVAILABLE_BY_DOCTOR, {
      skip: !medicalStaffId,
      fetchPolicy: "network-only",
      variables: {
        where: { medicalStaffId, branchOfficeId, pharmacyProviderId },
      },
    });

  const available = Number(getPrescriptionAvailableByDoctor?.amount || 0);

  const hasPrescriptionAvailability = (recipeType, quantity = 1) =>
    !requiresPrescriptionPurchase(recipeType) || available >= (quantity || 1);

  return { available, loading, refetch, hasPrescriptionAvailability };
}
